import { render } from "./SeletorCor.vue?vue&type=template&id=684b2380&scoped=true"
import script from "./SeletorCor.vue?vue&type=script&lang=js"
export * from "./SeletorCor.vue?vue&type=script&lang=js"

import "./SeletorCor.vue?vue&type=style&index=0&id=684b2380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684b2380"]])

export default __exports__